import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  CardMedia,
  TextField,
  CircularProgress,
  createMuiTheme,
  ThemeProvider,
  Avatar,
} from "@material-ui/core";
//FB 4574 DK - Removed unused imports
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Context, Facility, FacilityRegion } from "../store";
import { get_Facilities, modify_AppointmentDetails } from "../actions";
import { useHistory } from "react-router-dom";
import useStyles from "../css/styles";
import { GetFacilityRegions, InsertPELogs } from "../api"; //FB 4960
import globalsettings from "../../../config"; //FB 4960

// update log
// FB 4371 DK   03/29/2021    Added for Location module in home page
// FB 4371 DK   04/20/2021    Fixed image src issue
// FB 4574 DK   07/15/2021    Added styling for dropdown icon
// FB 4657 MS   08/27/2021    Fixed the issue where same state displays twice in region dropdown
// FB 4960 BR   07/03/2022    Logging all actions on PE
// FB 6264 DK   11/22/2022    Migrate PE API,DB to EMR
// FB 7801 SK   12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 8290 MS   04/29/2024    Get Facility Picture from EMR
// FB 8722 DK   11/06/2024    PE workflows enhancements

export default function Location(props: any) {
  //FB-6264
  const { state, dispatch } = useContext(Context);
  const [facilities, setFacilities] = React.useState<Facility[]>([]);
  //FB-6264
  const [facilitiesopen, setFacilitiesOpen] = React.useState(false);
  const facilitiesLoader = facilitiesopen && facilities.length === 0;
  const [regions, setRegions] = React.useState<FacilityRegion[]>([]);
  //FB-6264
  const [regionsopen, setRegionsOpen] = React.useState(false);
  const regionsLoader = regionsopen && regions.length === 0;
  const styles = useStyles();

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });

  const [selectedfacility, setSelectedfacility] = useState<Facility>({
    id: state.appointmentdetails.location.id,
    name: state.appointmentdetails.location.name,
    address: state.appointmentdetails.location.address,
    region: state.appointmentdetails.location.region,
    phone: state.appointmentdetails.location.phone,
  });

  const [selectedregion, setSelectedRegion] = useState({
    id: state.appointmentdetails.location.region,
    name: state.region.name,
    state: state.region.state,
  });
  //FB 8722
  const [isSingleRegion, setIsSingleRegion] = useState(0);
  const [isSingleLocation, setIsSingleLocation] = useState(0);

  //FB 4371 DK    Added to load the region list
  useEffect(() => {
    GetFacilityRegions().then((data) => {
      setRegions(data);
      // FB 8722
      if (data.length == 1) {
        setIsSingleRegion(1);
        let value = data[0];
        setSelectedRegion({ id: value.id, name: value.name, state: value.state });
        state.region.id = value.id;
        state.region.name = value.name;
        state.region.state = value.state;
      }
    });
  }, []);

  //FB 4371 DK    Added to get facilities list
  useEffect(() => {
    if (!state.facilities || state.facilities.length === 0) {
      get_Facilities(state.appointmentdetails.insurance.id, dispatch).then(
        (data) => {
          setFacilities(state.facilities);
        }
      );
    }
  }, []);

  //FB 6264
  useEffect(() => {
    setFacilities(state.facilities);
  });

  //FB 8722
  useEffect(() => {
    if (facilities.filter((facility) => facility.region === selectedregion.id).length == 1) {
      setIsSingleLocation(1);
      let value = state.facilities[0];
      setSelectedfacility(state.facilities[0] as Facility);
      modifyState(value);
    }
  }, [facilities]);

  //FB 4371 DK    Added to modify the state when region is selected
  const handleRegionChange = (event: any, value: any) => {
    if (value != null) {
      setSelectedRegion({ id: value.id, name: value.name, state: value.state });
      state.region.id = value.id;
      state.region.name = value.name;
      state.region.state = value.state;
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Selected the region " + value.name);
      //FB 4960 End
    } else {
      setSelectedRegion({
        id: 0,
        name: "",
        state: "",
      });
    }
    setSelectedfacility({
      id: 0,
      name: "",
      address: "",
      region: 0,
    });
  };

  //FB 4371 DK    Added to modify the state when facility is selected
  const handleChange = (event: any, value: any) => {
    if (value != null) {
      setSelectedfacility(value as Facility);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Selected the location " + value.name);
      //FB 4960 End
      //FB 8722
      modifyState(value);
    } else {
      setSelectedfacility({
        id: 0,
        name: "",
        address: "",
        region: 0,
      });
    }
  };

  //FB 4960
  const handleGoback = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - by office location");
    //FB 4960 End
    props.onCallbackType("");
  };

  const history = useHistory();

  //FB 4371 DK    Added to navigate to slots page
  //FB 4960
  const handleProceed = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by office location");
    //FB 4960 End
    history.push("/slots_bylocation", state);
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //FB 8722
  function modifyState(value: any) {
    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
        patientType: state.appointmentdetails.patientType,
        isInsuranceExist: state.appointmentdetails.isInsuranceExist,
        insurance: {
          id: state.appointmentdetails.insurance.id,
          planId: state.appointmentdetails.insurance.planId,
          name: state.appointmentdetails.insurance.name,
          planName: state.appointmentdetails.insurance.planName,
        },
        appointmentfilter: state.appointmentdetails.appointmentfilter,
        provider: {
          id: 0,
          name: "",
        },
        location: {
          id: value.id,
          name: value.name,
          address: value.address,
          region: selectedregion.id,
          phone: value.phone,
        },
        date: new Date(),
      },
      dispatch
    );
  }

  return (
    <div ref={scrollTo}>
      {/* FB 8722 */}
      <Grid container spacing={2} style={{ display: isSingleRegion == 0 ? "flex" : "none" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the region</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="regionlist"
              className={styles.dropdown_nomargin}
              fullWidth
              onChange={handleRegionChange}
              value={{
                id: selectedregion.id,
                name: selectedregion.name,
                state: selectedregion.state,
              }}
              //FB 4657 Begin
              options={regions.sort((a, b) => -b.state.localeCompare(a.state))}
              getOptionLabel={(option) => option.name}
              //FB 4657 End
              groupBy={(options) => options.state}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              // FB 4574 DK - Added styling for dropdown icon
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              //FB-6264
              open={regionsopen}
              loading={regionsLoader}
              onOpen={() => {
                setRegionsOpen(true);
              }}
              onClose={() => {
                setRegionsOpen(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Region"
                  id="region"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      //FB-6264
                      <React.Fragment>
                        {regionsLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      {/* FB 8722 Start*/}
      <Grid container spacing={2} style={{ display: isSingleRegion == 1 ? "flex" : "none" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Selected region</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <label>{selectedregion.name}</label>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedregion.id > 0 && isSingleLocation == 0 ? "flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the location</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <ThemeProvider theme={theme}>
            {/* FB-6264 */}
            <Autocomplete
              id="facilitylist"
              className={styles.dropdown_nomargin}
              fullWidth
              onChange={handleChange}
              value={{
                id: selectedfacility.id,
                name: selectedfacility.name,
                address: selectedfacility.address,
                region: selectedfacility.region,
              }}
              getOptionLabel={(option) => option.name}
              options={facilities.filter(
                (facility) => facility.region === selectedregion.id
              )}
              groupBy={(option) =>
                option.InsuranceAcceptance &&
                  state.appointmentdetails.isInsuranceExist === "Yes"
                  ? option.InsuranceAcceptance
                  : ""
              }
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              // FB 4574 DK - Added styling for dropdown icon
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              open={facilitiesopen}
              loading={facilitiesLoader}
              onOpen={() => {
                setFacilitiesOpen(true);
              }}
              onClose={() => {
                setFacilitiesOpen(false);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location"
                  id="location"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {facilitiesLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedregion.id > 0 && isSingleLocation == 1 ? "flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Selected location</Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <label>{selectedfacility.name}</label>
        </Grid>
      </Grid>
      {/* FB 8722 End*/}
      <Grid
        container
        spacing={2}
        style={{
          display: selectedfacility.id > 0 ? "flex" : "none",
        }}
      >
        <Grid item xs={12} sm={6} md={5}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={5}
          style={{
            display: "flex",
            justifyContent: window.innerWidth <= 768 ? "center" : "",
          }}
        >
          <Card className={styles.location_Card}>
            <CardMedia style={{ display: "flex", justifyContent: "center" }}>
              {/* FB 4371 DK - Changes the src syntax */}
              {/* FB 8290 MS - Changes the src */}
              <Avatar
                style={{ margin: 5 }}
                className={styles.card_Avatar}
                src={`${globalsettings.emrAPI}media/facilties/${selectedfacility.id}.jpg`}
              />
            </CardMedia>
            <CardContent>
              <Typography id="selectedFacilityName" variant="h6">
                <b>{selectedfacility.name}</b>
              </Typography>
              <Typography id="selectedfacility">
                {selectedfacility.address.includes("null")
                  ? ""
                  : selectedfacility.address}
              </Typography>
              <Typography>
                {selectedfacility.phone !== ""
                  ? "(" +
                  selectedfacility.phone?.slice(0, 3) +
                  ") " +
                  selectedfacility.phone?.slice(3, 6) +
                  "-" +
                  selectedfacility.phone?.slice(6, 10)
                  : ""}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={3} className={styles.flexend_Grid}>
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: selectedfacility.id > 0 ? "block" : "none",
          }}
        >
          <Button
            variant="contained"
            id="showScheduleLocation"
            className={styles.navigationButton}
            onClick={handleProceed}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={4} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            onClick={handleGoback}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
